import { Select } from "components/shared/form";
import { requiredField } from "helpers/validators";
import moment from "moment";
import React from "react";
import { list } from "sources/books/customPointTypes";

const CustomPointType = (props) => {
    const { isDisabled, i, value, planLeaveDate, planEnterDate, isEmptyMileageBid } = props;
    const onChange = ({ name, value, option }) => {
        props.onChange({ name, value, option });
        if (!isEmptyMileageBid && option && !planLeaveDate && planEnterDate) {
            setTimeout(() => {
                onChange({
                    name: "planLeaveDate",
                    value: moment(planEnterDate).add(option.planStayPeriod, "h").format(),
                });
            }, 0);
        }
    };

    return (
        <Select
            wrapper="book-field"
            fieldWrapper="col-sm-8 col-md-5"
            inputProps={{
                name: "customPointTypeId",
            }}
            propName="name"
            url={list}
            onChange={onChange}
            value={value}
            index={i}
            required
            unClearable
            validators={[requiredField]}
            disabled={isDisabled}
            label="Тип точки"
        />
    );
};

export default CustomPointType;
